import React, { Component } from 'react';

class GeckoCardFooter extends Component {

    render() {
        return (
        	<div className="footer p-6 pt-0 flex flex-col gap-2">
				{this.props.children}
			</div>         
        );
    }
}

export default GeckoCardFooter;